(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }

              var swiper = new Swiper(".product-recommendations", {
              lazy: true,
              slidesPerView: 5,
              spaceBetween: 30,
                navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
              breakpoints: {
                320: {
                  spaceBetween: 10,
                  slidesPerView: 2.3
                },
                768: {
                  slidesPerView: 3.5
                },
                1024: {
                  spaceBetween: 20,
                  slidesPerView: 4
                },
                1200: {
                  slidesPerView: 5
                }
              }
            });
            
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
